import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminHeader from '../../components/admin/AdminHeader';
import authService from '../../services/authService';
import api from '../../services/api';

function PartnersPage() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [adminUser, setAdminUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!authService.isAdminLoggedIn()) {
      navigate('/admin/login');
      return;
    }

    const userData = authService.getAdminUser();
    if (!userData) {
      navigate('/admin/login');
      return;
    }

    setAdminUser(userData);
  }, [navigate]);

  useEffect(() => {
    if (adminUser) {
      fetchPartners();
    }
  }, [adminUser]);

  const fetchPartners = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.getPartners();
      setPartners(response.data.partners || []);
    } catch (err) {
      console.error('Error fetching partners:', err);
      setError('Failed to load partners');
    } finally {
      setLoading(false);
    }
  };

  const handlePartnerClick = (partnerId) => {
    navigate(`/admin/partners/${partnerId}`);
  };

  if (!adminUser) return <div>Loading...</div>;

  return (
    <div>
      <AdminHeader adminUser={adminUser} />
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '20px' 
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px'
        }}>
          <h1>Partners</h1>
        </div>

        {error && (
          <div style={{
            padding: '15px',
            marginBottom: '20px',
            backgroundColor: '#fee2e2',
            border: '1px solid #ef4444',
            borderRadius: '8px',
            color: '#dc2626'
          }}>
            {error}
          </div>
        )}

        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            Loading partners...
          </div>
        ) : partners.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '40px',
            backgroundColor: '#f9fafb',
            borderRadius: '8px',
            border: '1px solid #e5e7eb'
          }}>
            <p>No partners found</p>
          </div>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '20px'
          }}>
            {partners.map((partner) => (
              <div
                key={partner._id}
                onClick={() => handlePartnerClick(partner._id)}
                style={{
                  padding: '20px',
                  backgroundColor: '#ffffff',
                  border: '1px solid #e5e7eb',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.15)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '15px'
                }}>
                  <div style={{
                    width: '48px',
                    height: '48px',
                    backgroundColor: '#4f46e5',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '15px'
                  }}>
                    <span style={{
                      color: 'white',
                      fontSize: '20px',
                      fontWeight: 'bold'
                    }}>
                      {partner.displayName?.charAt(0).toUpperCase() || 'P'}
                    </span>
                  </div>
                  <div>
                    <h3 style={{ margin: '0 0 5px 0', fontSize: '18px', color: '#111827' }}>
                      {partner.displayName}
                    </h3>
                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                      {partner.partnerKey}
                    </p>
                  </div>
                </div>

                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  paddingTop: '15px',
                  borderTop: '1px solid #e5e7eb'
                }}>
                  <span style={{
                    display: 'inline-block',
                    padding: '4px 12px',
                    borderRadius: '100px',
                    fontSize: '12px',
                    fontWeight: '500',
                    backgroundColor: partner.isActive ? '#dcfce7' : '#fee2e2',
                    color: partner.isActive ? '#166534' : '#dc2626'
                  }}>
                    {partner.isActive ? 'Active' : 'Inactive'}
                  </span>
                  <span style={{
                    fontSize: '14px',
                    color: '#4f46e5',
                    fontWeight: '500'
                  }}>
                    View Details →
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PartnersPage;
